import {
  I_Order,
  I_Paginator,
  I_PayloadGetListOrder,
} from 'app/pages/Account/ListOrder/slice/types';
import { BaseXHR } from 'utils/axios';

export const loginApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/login', data);

export const registerApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/register', data);

export const verifyOTPApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/confirm', data);

export const logoutApi = () => BaseXHR.$post('b2b/v1/account/logout');

export const getMeApi = payload => BaseXHR.$get('b2b/v1/account/get', payload);

export const updateMeApi = (payload: FormData) =>
  BaseXHR.$post('b2b/v1/account/update', payload);

export const getListOrderApi = (payload: I_PayloadGetListOrder) =>
  BaseXHR.$get<{
    data: I_Order[];
    orderCount: {
      cancelled: number;
      paymentPending: number;
      success: number;
    };
    paginator: I_Paginator;
  }>('b2b/v1/order/listing', payload);

export const getListItemApi = payload =>
  BaseXHR.$get('b2b/v1/item/listing', payload);

export const forgotPasswordApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/send-otp-password', data);

export const verifyOTPChangePassApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/confirm-change-password', data);

export const updatePassApi = (data: FormData) =>
  BaseXHR.$post('b2b/auth/update-password', data);
export const reSendRegisterOTP = (data: FormData) =>
  BaseXHR.$post('b2b/auth/resend-otp', data);

export const cancelOrderApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/order/cancel', data);

export const createAgentApi = (data: FormData) => {
  return BaseXHR.$post('b2b/v1/agency/create', data);
};

export const getAutoDepositUrl = (data: FormData) => {
  return BaseXHR.$post('b2b/v1/topup/get-url', data);
};

export const getAutoDepositDetail = (id: string) => {
  return BaseXHR.$get('b2b/v1/topup/detail?id=' + id);
};

export const cancelTopupDepositQR = () => {
  return BaseXHR.$get('b2b/v1/topup/destroy');
};

export const getTopupHistory = (payload: Record<string, string>) => {
  return BaseXHR.$get('b2b/v1/topup/listing', payload);
};

export const exportTopupHistory = (payload: Record<string, string>) => {
  return BaseXHR.$get('b2b/v1/topup/listing-csv', payload);
};
